import {FormFieldsProps} from "../../calculator";

export const formFields: FormFieldsProps<string | number>[] = [
  {
    fieldName: "pricePerMile",
    label: "Price Per Mile",
    col: "col-md-4",
    required: true,
    type: "number"
  },
  {
    fieldName: "pricePerPerson",
    label: "Price Per Person",
    col: "col-md-4",
    required: true,
    type: "number"
  },
  {
    fieldName: "boatCapacity",
    label: "Boat Capacity",
    col: "col-md-4",
    required: true,
    type: "number"
  },
  {
    fieldName: 'allowSubmitRide',
    label: "Allow Request Ride",
    col: "col-md-3",
    required: true,
    type: "checkbox",
    value: 'allowSubmitRide'
  },
  {
    fieldName: 'noRideMessage',
    label: "No Ride Message",
    col: "col-md-9",
    required: true,
    type: 'text',
  },
  {
    fieldName: 'submitRideMessage',
    label: "Submit Ride Message",
    col: "",
    required: true,
    type: 'text',
  }
];

export interface ConfigState {
  loading: boolean;
  config?: any;
}

export const defaultState: ConfigState = {
  loading: true,
  config: {
    pricePerMile: 0,
    pricePerPerson: 0,
    boatCapacity: 0
  }
}